import { startCase } from 'lodash'
import { cn, Label, Select } from 'twyne-new.ui'

export default function PasteIntoSelect({ selected, className }) {
  return <div className={cn('flex flex-col gap-1.5 relative', className)}>
    <Label className='twy-text-base-accent absolute -top-5 left-0'>Paste into</Label>
    <Select
      options={[]}
      value={selected ? { label: startCase(selected), value: selected } : null}
      onChange={() => {}}
      placeholder='No editor available'
      controlClassName='h-10 py-0'
      disabled
      insideSheet
    />
  </div>
}
